import { Controller } from '@hotwired/stimulus'

// Кнопка системного меню «Поделиться» (navigator.share): Telegram, Slack,
// WhatsApp и всё, что установлено на устройстве. API есть не везде (в
// основном мобильные браузеры и Safari), поэтому кнопка приходит скрытой и
// появляется только при поддержке — как в quiz_controller.js.
//
// Ссылка уже в конце текста (SharedMatchHelper#match_share_text), отдельным
// полем url её не передаём: часть приложений дописала бы её второй раз.
export default class NativeShareController extends Controller {
  static targets = ['button']
  static values = { text: String }

  connect() {
    if (typeof navigator.share !== 'function') return

    this.buttonTargets.forEach((button) => {
      button.hidden = false
    })
  }

  share() {
    navigator.share({ text: this.textValue }).catch(() => {
      // Отмена меню пользователем (AbortError) — не ошибка, показывать нечего.
    })
  }
}
